import { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isMarketingAdminAction } from "@redux/actions/authActions";
import { LoadingToRedirect } from "@components";
import VerticalLayout from "@layouts/VerticalLayout";

const MarketingAdminRoute = ({ children, ...restProps }) => {
  const dispatch = useDispatch();
  const [ok, setOk] = useState(false);

  // Check if current user is marketing admin
  useEffect(() => {
    dispatch(isMarketingAdminAction({ setOk }));
  }, []);

  return (
    <>
      {ok ? (
        <VerticalLayout>
          <Route {...restProps} render={children} />
        </VerticalLayout>
      ) : (
        <LoadingToRedirect />
      )}
    </>
  );
};

export default MarketingAdminRoute;
